import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n\n  p {\n    color: ",
        ";\n    text-align: center;\n    font-size: 16px;\n    line-height: 1.5;\n    letter-spacing: -0.16px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  background-color: rgba(169, 175, 199, 0.2);\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: center;\n  cursor: pointer;\n  height: 80px;\n  transition: all 0.3s;\n\n  img {\n    width: 316px;\n    height: 80px;\n  }\n\n  :hover {\n    background-color: rgba(169, 175, 199, 0.35);\n  }\n\n  &.fullWidth {\n    border-radius: 0;\n  }\n\n  &.default {\n    border-radius: 6px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 20px;\n\n  &.productDetail {\n    margin-top: 48px;\n    @media (max-width: 768px) {\n      margin-top: 32px;\n      flex-direction: column;\n    }\n  }\n\n  &.search {\n    margin-top: 36px;\n    @media (max-width: 768px) {\n      margin: 0 -16px;\n      a {\n        border-radius: 0;\n      }\n    }\n  }\n\n  &.moSide {\n  }\n\n  &.globalMenu {\n    flex-direction: column;\n  }\n\n  &.solvookPlus {\n    margin-top: 20px;\n\n    a {\n      border-radius: 12px;\n      border: 1px solid ",
        ";\n      box-shadow: 3px 3px 12px 0px rgba(28, 31, 46, 0.06);\n      background-color: #fff;\n      transition: all 0.3s;\n      height: 100%;\n\n      img {\n        border-radius: 12px;\n        height: 100%;\n        max-width: 340px;\n        width: 100%;\n        aspect-ratio: 340 / 110;\n      }\n\n      :hover {\n        border: 1px solid ",
        ";\n      }\n    }\n  }\n\n  &.brand {\n    @media (max-width: 1200px) {\n      a {\n        border-radius: 0;\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { useQuery } from "@tanstack/react-query";
import Link from "next/link";
import { getAdBanner } from "src/api/adBanner";
import styled from "styled-components";
export const useAdBannerQuery = (param)=>{
    let { position , subject , pageId  } = param;
    const { isLoading: isAdBannerLoading , isError: isAdBannerError , data: adBannerResponse , isSuccess: isAdBannerSuccess  } = useQuery([
        "adBanner",
        position,
        subject,
        pageId
    ], ()=>getAdBanner({
            position,
            subject,
            pageId
        }), {
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        select: (data)=>{
            if (position === "passes") {
                return {
                    items: data.items.slice(0, 1)
                };
            }
            return data;
        }
    });
    return {
        isAdBannerLoading,
        isAdBannerError,
        adBannerResponse,
        isAdBannerSuccess,
        noAdItems: !!!adBannerResponse || adBannerResponse.items.length === 0
    };
};
export const AdBannerItem = (param)=>{
    let { shape ="default" , link , imageUrl , id , mixpanelPosition  } = param;
    //외부 url은 새창으로 열기
    const isCurrentTab = link === null || link === void 0 ? void 0 : link.includes("https://solvook.com");
    return /*#__PURE__*/ _jsx(AdBannerItemContainer, {
        onClick: ()=>mixpanelEvent("AD Banner Clicked", {
                ID: id,
                "Button URL": link,
                position: mixpanelPosition
            }),
        className: "".concat(shape, " adbanner-item"),
        href: link,
        target: !isCurrentTab ? "_blank" : "_self",
        children: /*#__PURE__*/ _jsx("img", {
            src: imageUrl,
            alt: "광고 이미지"
        })
    });
};
export const AdBannerLayout = (param)=>{
    let { children , position  } = param;
    return /*#__PURE__*/ _jsx(AdBannerLayoutContainer, {
        className: "adbanner-container ".concat(position),
        children: children
    });
};
//moside empty
export const AdBannerEmpty = ()=>{
    return /*#__PURE__*/ _jsx(AdBannerEmptyContainer, {
        children: /*#__PURE__*/ _jsx("p", {
            children: "진행중인 이벤트가 없습니다."
        })
    });
};
export const AdBannerList = Object.assign(AdBannerLayout, {
    Item: AdBannerItem,
    Empty: AdBannerEmpty
});
const AdBannerEmptyContainer = styled.div.withConfig({
    componentId: "sc-dbefaebe-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_gray_500);
export const AdBannerItemContainer = styled(Link).withConfig({
    componentId: "sc-dbefaebe-1"
})(_templateObject1());
const AdBannerLayoutContainer = styled.div.withConfig({
    componentId: "sc-dbefaebe-2"
})(_templateObject2(), (props)=>props.theme.new.colors.sol_gray_50, (props)=>props.theme.new.colors.sol_gray_200);
